import React from "react";
import { Margin } from "~/components/elements";

import * as S from "../WinnerModal/styles";

import Exit from "~/assets/img/icon/modal-close.svg";
import ReactSVG from "react-svg";
import isMobile from "~/hooks/isMobile";
import sadFaceIcon from "~/assets/img/icon/sadFaceIcon.svg";

export default function FaileModal({ openModal, handleModal }) {
  const mobile = isMobile();
  return (
    <S.Shade
      open={!!openModal}
      onClick={() => {
        handleModal(false);
      }}
    >
      <S.ModalBox
        open={!!openModal}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        {!mobile && (
          <S.Exit onClick={() => handleModal(false)}>
            <ReactSVG wrapper="div" src={Exit} />
          </S.Exit>
        )}
        <S.TitleHolder>
          <Margin mb={2}>
            <ReactSVG src={sadFaceIcon} />
          </Margin>
          VALE PRÊMIO INSTANTÂNEO
        </S.TitleHolder>

        <S.Text>
        Poxa, não foi dessa vez!         
        <br></br>
          Continue cadastrando mais comprovantes fiscais para ter mais chances de ganhar</S.Text>
        <S.Button onClick={() => handleModal(false)}>
          OK
        </S.Button>

      </S.ModalBox>
    </S.Shade>
  );
}
